import type {
  HotelContentDescription,
  HotelContentImage,
  HotelContentLocation,
} from '@bandido/shared/types/hotels/hotel-content';
export interface EditorialSnapshot {
  display_name?: string | null;
  category_code?: string | null;
  location?: HotelContentLocation | null;
  descriptions?: HotelContentDescription[] | null;
  images?: HotelContentImage[] | null;
}
export interface Publication {
  hotel_id: string;
  published: boolean;
  version: number;
  snapshot: EditorialSnapshot;
  overrides: EditorialSnapshot;
  updated_at: string;
}
export function inheritedField<K extends keyof EditorialSnapshot>(
  source: EditorialSnapshot,
  overrides: EditorialSnapshot,
  key: K,
): EditorialSnapshot[K] {
  return Object.prototype.hasOwnProperty.call(overrides, key) ? overrides[key] : source[key];
}
export function restoreField(overrides: EditorialSnapshot, key: keyof EditorialSnapshot) {
  const next = { ...overrides };
  delete next[key];
  return next;
}
export function previewKey(version: number, overrides: EditorialSnapshot, language: string) {
  return JSON.stringify({ version, overrides, language });
}
export function moveImage(images: HotelContentImage[], index: number, delta: number) {
  const target = index + delta;
  if (target < 0 || target >= images.length) return images;
  const result = [...images];
  [result[index], result[target]] = [result[target], result[index]];
  return result;
}
